import axios from "axios";
import { refreshToken } from "./authService";

const api = axios.create({
  baseURL: 'https://panel.transkyrios.com/',
  withCredentials: true, 
  headers: {
    'x-perfil-id': localStorage.getItem('perfilActivo') || '',
  }
});

api.interceptors.request.use((config) => {
  const perfilActivo = localStorage.getItem('perfilActivo');
  if (perfilActivo) {
    config.headers['x-perfil-id'] = perfilActivo;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if ( error.response?.status !== 401 || originalRequest._retry) { 
      return Promise.reject(error); 
    }

    originalRequest._retry = true;

    try {
      // Pide nuevo token
      await refreshToken();

      // Reintenta solicitud original que falló
      return api(originalRequest);
      
    } catch (refreshError) {
      const mensaje =
        refreshError.response?.data?.msg ||
        'Sesión expirada. Inicie sesión nuevamente.';

      // Guardar el mensaje para mostrarlo en e login
      sessionStorage.setItem('mensajeSesion', mensaje);
      // Limpiar datos locales de la sesión
      localStorage.removeItem('perfilActivo');
      // Redirige al login
      window.location.href = '/auth/login';

      return Promise.reject(refreshError);
    }
  }
);

export default api;